import {
	ADMIN_SEARCH_FILTER_TYPE,
	AdminSearchRequest,
	DateRange,
	IOpportunityResponse,
	ISearchOpportunitiesSort,
	PaginationRequest,
	SearchOpportunitiesSort,
} from '@joc/api-gateway/lib/api-client';
import { formatInteger } from 'core/functions/formatNumber';

export type SuperAdminOpportunitiesFilters = {
	startDay?: {
		fromDate?: Date;
		toDate?: Date;
	};
	organisationIds?: Array<number>;
};

export type SuperAdminOpportunitiesState = {
	search?: string;
	sort?: ISearchOpportunitiesSort;
	filters?: SuperAdminOpportunitiesFilters;
};

export const formatDurationHoursMinutes = (durationSeconds: number): string => {
	const hours = Math.floor(durationSeconds / 3600);
	const minutes = Math.floor((durationSeconds % 3600) / 60);
	return `${formatInteger(hours)}h ${formatInteger(minutes)}m`;
};

export const formatCategory = (tag?: string | null): string => {
	if (!tag) return '';
	return `#${tag}`;
};

const PRIVATE_CHALLENGE_ORGANIZATION_LABEL = 'Private';

export const getChallengeOpportunityOrganizationLabel = (opportunity: IOpportunityResponse): string => {
	const organizationName = opportunity.organisation?.organizationName?.trim();
	return organizationName || PRIVATE_CHALLENGE_ORGANIZATION_LABEL;
};

export const buildAdminSearchRequest = ({
	opportunityFilterType,
	state,
	pagination,
}: {
	opportunityFilterType: ADMIN_SEARCH_FILTER_TYPE;
	state: SuperAdminOpportunitiesState;
	pagination?: PaginationRequest;
}): AdminSearchRequest => {
	const filters = state.filters || {};

	return AdminSearchRequest.fromJS({
		opportunityFilterType,
		...(pagination ? { pagination } : {}),
		...(state.search ? { search: state.search } : {}),
		...(state.sort ? { sort: SearchOpportunitiesSort.fromJS(state.sort) } : {}),
		...(filters.startDay?.fromDate || filters.startDay?.toDate
			? { startDay: DateRange.fromJS(filters.startDay) }
			: {}),
		...(filters.organisationIds?.length ? { organisationIds: filters.organisationIds } : {}),
	} as any);
};
